// Models
import { UnitPeriodChannelDto } from '../../modules/channel/models/unit-period-channel-dto.model';
import { JobDataPoint } from '../../modules/job/models';

export class WidgetHelper {
    static getThresholdClass(channelValue: JobDataPoint, unitPeriodChannel: UnitPeriodChannelDto) {
        let thresholdClass = '';

        if ((unitPeriodChannel.highDanger !== null && channelValue.v >= unitPeriodChannel.highDanger) || (unitPeriodChannel.lowDanger !== null && channelValue.v <= unitPeriodChannel.lowDanger)) {
            thresholdClass = ThresholdClassTypes.borderBlinkRed;
        } else if ((unitPeriodChannel.highWarning !== null && channelValue.v >= unitPeriodChannel.highWarning) || (unitPeriodChannel.lowWarning !== null && channelValue.v <= unitPeriodChannel.lowWarning)) {
            thresholdClass = ThresholdClassTypes.borderBlinkYellow;
        }

        return thresholdClass;
    }
}

export enum ThresholdClassTypes {
    borderBlinkRed = 'borderBlinkRed',
    borderBlinkYellow = 'borderBlinkYellow'
}
